<form class="search-input" [ngClass]="{ 'search-input__main--active': value.length }" (submit)="search()">
  <input #inputEl class="search-input__input" type="text" name="search" [placeholder]="placeholder" [(ngModel)]="value" (input)="input()" />
  @if (value.length) {
    <button class="search-input__clear" [@popFromRight] [type]="'button'" (click)="clear()">
      <app-icon class="search-input__clear-icon" [icon]="'close'" [width]="12"></app-icon>
    </button>
  }
</form>
